<template>
    <div>
        <el-row class="main">
            <div class="card-box">
                <!-- 右边卡片 -->
                <div class="card-rb">
                    <div class="card-4">
                        <el-card>
                            <div>
                                <el-form
                                    :inline="true"
                                    class="demo-form-inline"
                                    size="mini"
                                >
                                    <!-- <el-form-item label="证件编号:">
                    <el-input v-model="searchList.certificateNumber" placeholder="请输入证件编号"></el-input>
                  </el-form-item> -->
                                    <el-form-item label="姓名:">
                                        <el-input
                                            v-model="searchList.name"
                                            placeholder="请输入姓名"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="文化程度:">
                                        <el-select
                                            v-model="
                                                searchList.degreeOfEducation
                                            "
                                            placeholder="请选择"
                                        >
                                            <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button
                                            type="primary"
                                            @click="getList"
                                            >查询</el-button
                                        >
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button
                                            type="info"
                                            @click="searchReset()"
                                            >重置</el-button
                                        >
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="three">
                                <el-button
                                    type="primary"
                                    size="mini"
                                    @click="addFunc()"
                                    >新增</el-button
                                >
                            </div>
                            <!-- 表格盒子 -->
                            <div class="table_card">
                                <el-table
                                    ref="singleTable"
                                    :data="tableData"
                                    highlight-current-row
                                    style="width: 100%; margin-top: 16px"
                                    border
                                >
                                    <el-table-column
                                        label="序号"
                                        type="index"
                                        align="center"
                                        width="50"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="certificateNumber"
                                        align="center"
                                        label="证件编号"
                                        :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="name"
                                        align="center"
                                        label="姓名"
                                        :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="idCode"
                                        align="center"
                                        label="身份证号"
                                        :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="birthday"
                                        align="center"
                                        label="出生年月"
                                        :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="phone"
                                        align="center"
                                        label="联系方式"
                                        :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                        prop="sex"
                                        align="center"
                                        width="50"
                                        label="性别"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.sex == 0"
                                                >男</span
                                            >
                                            <span v-if="scope.row.sex == 1"
                                                >女</span
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="degreeOfEducation"
                                        align="center"
                                        width="70"
                                        label="学历"
                                        :show-overflow-tooltip="true"
                                    >
                                        <template slot-scope="scope">
                                            <span
                                                v-if="
                                                    scope.row
                                                        .degreeOfEducation == 0
                                                "
                                                >初中</span
                                            >
                                            <span
                                                v-if="
                                                    scope.row
                                                        .degreeOfEducation == 1
                                                "
                                                >高中</span
                                            >
                                            <span
                                                v-if="
                                                    scope.row
                                                        .degreeOfEducation == 2
                                                "
                                                >职校</span
                                            >
                                            <span
                                                v-if="
                                                    scope.row
                                                        .degreeOfEducation == 3
                                                "
                                                >专科</span
                                            >
                                            <span
                                                v-if="
                                                    scope.row
                                                        .degreeOfEducation == 4
                                                "
                                                >本科</span
                                            >
                                            <span
                                                v-if="
                                                    scope.row
                                                        .degreeOfEducation == 5
                                                "
                                                >研究生</span
                                            >
                                            <span
                                                v-if="
                                                    scope.row
                                                        .degreeOfEducation == 6
                                                "
                                                >博士</span
                                            >
                                            <span
                                                v-if="
                                                    scope.row
                                                        .degreeOfEducation == 7
                                                "
                                                >其他</span
                                            >
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        prop="status"
                                        label="状态"
                                        :show-overflow-tooltip="true"
                                    >
                                        <template scope="scope">
                                            <el-switch
                                                v-model="scope.row.status"
                                                active-value="0"
                                                inactive-value="1"
                                                @change="
                                                    changeStatus(scope.row)
                                                "
                                            ></el-switch>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="approvalStatus" align="center" width="100" label="审核状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.approvalStatus == 0">待审核</span>
                        <span v-if="scope.row.approvalStatus == 1">审核通过</span>
                        <span v-if="scope.row.approvalStatus == 2">审核不通过</span>
                    </template> </el-table-column>   -->
                                    <el-table-column
                                        fixed="right"
                                        label="操作"
                                        align="center"
                                        width="230"
                                    >
                                        <template slot-scope="scope">
                                            <el-tooltip
                                                class="item"
                                                effect="dark"
                                                content="查看"
                                                placement="top-start"
                                            >
                                                <button
                                                    style="color: skyblue"
                                                    class="iconfont icon-chakan tabBtn"
                                                    @click="
                                                        look(
                                                            scope.row.id,
                                                            'look'
                                                        )
                                                    "
                                                ></button>
                                            </el-tooltip>
                                            <!-- <el-tooltip class="item" effect="dark"  v-if="scope.row.approvalStatus == '0'" content="审核" placement="top-start" >
                        <button
                          style="color:pink"
                          class="iconfont icon-shenhe tabBtn"
                          @click="look(scope.row.id,'approval')" 
                        ></button>
                      </el-tooltip> -->
                                            <el-tooltip
                                                class="item"
                                                effect="dark"
                                                content="修改"
                                                v-if="
                                                    scope.row.approvalStatus !=
                                                    '1'
                                                "
                                                placement="top-start"
                                            >
                                                <button
                                                    style="color: #2e99cf"
                                                    class="iconfont icon-bianji3 tabBtn"
                                                    @click="
                                                        look(
                                                            scope.row.id,
                                                            'edit'
                                                        )
                                                    "
                                                ></button>
                                            </el-tooltip>
                                            <el-tooltip
                                                class="item"
                                                effect="dark"
                                                content="删除"
                                                placement="top-start"
                                            >
                                                <button
                                                    style="color: red"
                                                    class="iconfont icon-icon7 tabBtn"
                                                    @click="
                                                        deletepanduan(
                                                            scope.row.id
                                                        )
                                                    "
                                                    key=""
                                                ></button>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <!-- 分页功能 -->
                            <el-pagination
                                :page-size="pageConfig.pageSize"
                                layout="total, prev, pager, next, jumper"
                                @current-change="handleCurrentChange"
                                :total="pageConfig.total"
                            ></el-pagination>
                        </el-card>
                    </div>
                </div>
                <!--弹框-->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="dialogFormVisible"
                    width="995px"
                    @close="clearForm()"
                >
                    <el-form
                        :model="formData"
                        ref="formData"
                        :rules="rules"
                        :label-position="labelPosition"
                        label-width="220px"
                    >
                        <el-form-item label="证件编号：">
                            <el-input
                                class="form_input"
                                :disabled="readonly"
                                v-model="formData.certificateNumber"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="姓名：">
                            <el-input
                                class="form_input"
                                :disabled="readonly"
                                v-model="formData.name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号：" prop="idCode">
                            <el-input
                                class="form_input"
                                :disabled="readonly"
                                v-model="formData.idCode"
                                autocomplete="off"
                                @blur="getName(formData.idCode)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="出生年月：" prop="name">
                            <el-date-picker
                                class="form_input"
                                :disabled="readonly"
                                v-model="formData.birth"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                placeholder="选择出生年月"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="联系电话：" prop="phone">
                            <el-input
                                class="form_input"
                                :disabled="readonly"
                                v-model="formData.phone"
                                autocomplete="off"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="性别：">
                            <el-select
                                class="form_input"
                                :disabled="readonly"
                                v-model="formData.sex"
                                placeholder="请选择"
                            >
                                <el-option label="男" value="0"></el-option>
                                <el-option label="女" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="文化程度：">
                            <el-select
                                class="form_input"
                                :disabled="readonly"
                                v-model="formData.degreeOfEducation"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="所属社会组织：">
                            <el-select
                                class="form_input"
                                :disabled="readonly"
                                v-model="formData.socialOrgId"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in socialOrgOptions"
                                    :key="item.id"
                                    :label="item.orgName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="服务类型：">
                            <el-checkbox-group
                                v-model="checkList"
                                class="form_input"
                            >
                                <el-checkbox :disabled="readonly" label="0"
                                    >社会福利</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="1"
                                    >社会救助</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="2"
                                    >社会慈善</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="3"
                                    >残障康复</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="4"
                                    >优抚安置</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="5"
                                    >医疗卫生</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="6"
                                    >司法矫治</el-checkbox
                                >
                                <el-checkbox :disabled="readonly" label="7"
                                    >青少年服务</el-checkbox
                                >
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item label="是否是社区工作人员：">
                            <el-radio-group
                                :disabled="readonly"
                                v-model="formData.communityPerson"
                            >
                                <el-radio label="0">是</el-radio>
                                <el-radio label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="上传图片：">
                            <el-upload
                                :disabled="readonly"
                                :action="url"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview2"
                                :on-success="imgok"
                                :file-list="fileListimg"
                                :on-remove="handleRemove2"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog
                                :visible.sync="dialogVisible1"
                                append-to-body
                            >
                                <img width="100%" :src="dialogImageUrl" alt />
                            </el-dialog>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-radio-group
                                :disabled="readonly"
                                v-model="formData.status"
                            >
                                <el-radio label="0">启用</el-radio>
                                <el-radio label="1">禁用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!-- <el-form-item label="备注" >
              <el-input class="form_input" :disabled="readonly" v-model="formData.remarks" autocomplete="off" type="textarea" :row="4"></el-input>
            </el-form-item> -->
                        <div v-if="auditsend == true" style="margin-top: 30px">
                            <el-form-item label="审核结果">
                                <template>
                                    <el-radio
                                        class="addradio"
                                        v-model="formData.approvalStatus"
                                        label="1"
                                        >审核通过</el-radio
                                    >
                                    <el-radio
                                        class="addradio"
                                        v-model="formData.approvalStatus"
                                        label="2"
                                        >审核不通过</el-radio
                                    >
                                </template>
                            </el-form-item>
                            <el-form-item label="审核意见">
                                <el-input
                                    class="form_input"
                                    v-model="formData.approvalOpinion"
                                    :autosize="{ minRows: 2 }"
                                    type="textarea"
                                    placeholder="审核不通过时,请填写此项"
                                ></el-input>
                            </el-form-item>
                        </div>
                        <el-form-item>
                            <div class="footer">
                                <el-button
                                    v-if="addsend == true"
                                    type="primary"
                                    @click="send()"
                                    >确 定</el-button
                                >
                                <el-button
                                    v-if="auditsend == true"
                                    type="primary"
                                    @click="approvalSend()"
                                    >审核</el-button
                                >
                                <el-button
                                    v-if="editsend == true"
                                    type="primary"
                                    @click="chengesend()"
                                    >修 改</el-button
                                >
                                <el-button type="info" @click="clearForm()"
                                    >取 消</el-button
                                >
                            </div>
                        </el-form-item>
                    </el-form>
                </el-dialog>
            </div>
        </el-row>
    </div>
</template>

<script>
import { post } from "@/api/requrestHttp"
import baseURL from "@/api/baseURL"
export default {
    data() {
        return {
            url:baseURL+
                "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            labelPosition: "right",
            dialogTitle: "新增",
            readonly: false,
            checked: true,
            addsend: false,
            editsend: false,
            auditsend: false,
            dialogFormVisible: false,
            searchList: {},
            fileListimg: [],
            pageConfig: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
            formData: {
                serviceTypess: [],
            },
            options: [
                { label: "初中", value: "0" },
                { label: "高中", value: "1" },
                { label: "职校", value: "2" },
                { label: "专科", value: "3" },
                { label: "本科", value: "4" },
                { label: "研究生", value: "5" },
                { label: "博士", value: "6" },
                { label: "其他", value: "7" },
                { label: "职校", value: "8" },
            ],
            socialOrgOptions: [],
            rules: {
                // name: [{ required: true, message: "请输入姓名", trigger: "blur" , trigger: "blur",}],
                // sex: [{ required: true, message: "请选择性别", trigger: "blur" , trigger: "blur",}],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (/^1[34578]\d{9}$/.test(value) == false) {
                                callback(new Error("请输入正确的手机号"))
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur",
                    },
                ],
                idCode: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: "blur",
                    },
                    {
                        pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                        message: "你的身份证格式不正确",
                    },
                ],
                // photo: [{ required: false, message: "请上传照片", trigger: "blur" }],
                // communityPerson: [{ required: true, message: "请选择是否是社区工作人员", trigger: "change", }],
                // status: [{ required: true, message: "请选择启动状态", trigger: "change", }],
            },
            imageUrl: "",
            isaudit: false, //审核界面是否显示审核按钮
            dialogImageUrl: "", //图片上传,
            dialogVisible1: false, // 上传模态框按钮
            value: "",
            checkList: [],
            input: "",
            value1: "",
            value2: "",
            isaudit: "",
            tableData: [],
        }
    },
    mounted() {
        this.getList()
        this.getSocialOrg()
    },
    methods: {
        // 获取社会组织
        getSocialOrg() {
            post("/admin/socialOrg/info/listSocialOrg", {
                pageNo: 1,
                pageSize: 999,
            }).then((res) => {
                console.log(res)
                this.socialOrgOptions = res.content.list
            })
        },
        getName(iden) {
            console.log(iden)
            let val = iden.length
            if (val === 18) {
                let year = iden.substring(6, 10)
                let month = iden.substring(10, 12)
                let day = iden.substring(12, 14)
                let age = year + "-" + month + "-" + day
                this.formData.birth = age
                console.log(this.formData.birth)
                this.$forceUpdate()
                this.$set(this.formData, "birth", age)
            }
        },
        //获取列表
        getList: async function () {
            post("/admin/socialWorker/info/listSocialWorker", {
                ...this.searchList,
                pageSize: this.pageConfig.pageSize,
                pageNo: this.pageConfig.pageNo,
            }).then((res) => {
                console.log(res)
                this.pageConfig.total = res.content.count
                this.tableData = res.content.list
                this.tableData.map((item) => {
                    item.birthday = item.birth.substring(0, 10)
                })
            })
        },
        //新增
        send() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    let serviceType = this.checkList.toString()
                    console.log(serviceType)
                    //循环拼接
                    var str = ""
                    if (Array.isArray(this.formData.photo)) {
                        this.formData.photo.map((item, index) => {
                            str += item + "#"
                        })
                    } else {
                        str = this.formData.photo
                    }
                    this.$set(this.formData, "photo", str)
                    let params = {
                        ...this.formData,
                        serviceType: serviceType,
                        approvalStatus: 0,
                    }
                    console.log(params)
                    post(
                        "admin/socialWorker/info/insertSocialWorker",
                        params
                    ).then((res) => {
                        console.log(res.content)
                        if (res.code == 200) {
                            this.$message({
                                message: "新增成功",
                                type: "success",
                            })
                            this.dialogFormVisible = false
                            this.clearForm()
                            this.getList()
                        }
                    })
                } else {
                    return false
                }
            })
        },
        //改变状态
        async changeStatus(cdata) {
            let params = cdata
            console.log(params)
            post("/admin/socialWorker/info/updateSocialWorker", params).then(
                (res) => {
                    console.log(res)
                    var msg = "状态"
                    msg = msg + (cdata.status == "0" ? "启用" : "禁用")
                    if (res.code == 200) {
                        this.$message({
                            message: msg + "成功",
                            type: "success",
                        })
                    } else {
                        console.log(res.message)
                        this.$message({
                            message: msg + "失败",
                            type: "error",
                        })
                    }
                }
            )
        },
        //修改提交方法
        chengesend() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    let serviceType = this.checkList.toString()
                    console.log(serviceType)
                    //循环拼接
                    var str = ""
                    if (Array.isArray(this.formData.photo)) {
                        this.formData.photo.map((item, index) => {
                            str += item + "#"
                        })
                    } else {
                        str = this.formData.photo
                    }
                    this.$set(this.formData, "photo", str)
                    let params = {
                        ...this.formData,
                        serviceType: serviceType,
                        approvalStatus: 0,
                    }
                    console.log(params)
                    post(
                        "/admin/socialWorker/info/updateSocialWorker",
                        params
                    ).then((res) => {
                        console.log(res.content)
                        if (res.code == 200) {
                            this.$message({
                                message: "新增成功",
                                type: "success",
                            })
                            this.dialogFormVisible = false
                            this.clearForm()
                            this.getList()
                        }
                    })
                } else {
                    return false
                }
            })
        },
        //删除方法
        deletepanduan: async function (id) {
            this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                console.log(3123123)
                post("/admin/socialWorker/info/deleteSocialWorker", {
                    id: id,
                }).then((res) => {
                    if (res.code == 200) {
                        this.$message({ message: "删除成功", type: "success" })
                        this.getList()
                    }
                })
            })
        },
        //打开弹框 -- 修改
        changedata(id, type) {
            this.fileListimg = []
            this.checkList = []
            this.formData = {}
            this.sendnum = false
            this.chengesendnum = true
            post("/admin/socialWorker/info/getSocialWorker", {
                id: id,
            }).then((res) => {
                if (res.code == 200) {
                    this.formData = res.content
                    console.log("formData", this.formData)
                    if (this.formData.photo) {
                        this.formData.photo = res.content.photo.split("#")
                        this.formData.photo.map((item1, index) => {
                            if (item1 == "") {
                                this.formData.photo.splice(index, 1)
                            }
                        })
                        console.log(this.formData.photo)
                        this.formData.photo.map((item) => {
                            this.fileListimg.push({
                                url: item,
                            })
                        })
                        console.log(this.fileListimg)
                    }
                    this.checkList = res.content.serviceType.split(",")
                    console.log(this.checkList)
                    this.dialogFormVisible = true
                } else {
                    this.$message({
                        message: "获取信息详情失败，请检查网络",
                        type: "error",
                    })
                }
            })
        },
        //审核按钮提交
        approvalSend() {
            let params = {
                id: this.formData.id,
                approvalStatus: this.formData.approvalStatus,
                approvalOpinion: this.formData.approvalOpinion,
            }
            console.log(params)
            post("/admin/socialWorker/info/updateSocialWorker", params).then(
                (res) => {
                    console.log(res.content)
                    if (res.code == 200) {
                        this.$message({ message: "审核成功", type: "success" })
                        this.dialogFormVisibleTwo = false
                        this.clearForm()
                        this.getList()
                    } else {
                        this.$message({ message: "审核失败", type: "error" })
                    }
                }
            )
        },
        //查看
        look(id, type) {
            this.dialogFormVisible = true
            this.fileListimg = []
            this.checkList = []
            this.formData = {}
            if (type == "look") {
                this.dialogTitle = "查看"
                this.readonly = true
                this.addsend = false
                this.editsend = false
                this.auditsend = false
            } else if (type == "approval") {
                this.dialogTitle = "审核"
                this.readonly = true
                this.addsend = false
                this.editsend = false
                this.auditsend = true
            } else if (type == "edit") {
                this.dialogTitle = "修改"
                this.readonly = false
                this.addsend = false
                this.editsend = true
                this.auditsend = false
            }
            if (this.formData.approvalStatus == "0" && type == "audit") {
                this.isaudit = true
            }
            post("/admin/socialWorker/info/getSocialWorker", {
                id: id,
            }).then((res) => {
                if (res.code == 200) {
                    this.formData = res.content
                    if (this.formData.photo) {
                        this.formData.photo = res.content.photo.split("#")
                        this.formData.photo.map((item1, index) => {
                            if (item1 == "") {
                                this.formData.photo.splice(index, 1)
                            }
                        })
                        this.formData.photo.map((item) => {
                            this.fileListimg.push({
                                url: item,
                            })
                        })
                    }
                    this.checkList = res.content.serviceType.split(",")
                } else {
                    this.$message({
                        message: "获取信息详情失败，请检查网络",
                        type: "error",
                    })
                }
            })
        },
        //展示消息提示
        showMsg: function (code, success, error) {
            if (code == 200) {
                this.$message({
                    message: success,
                    type: "success",
                })
                this.offondialog()
            } else {
                this.$message({
                    message: error,
                    type: "error",
                })
            }
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getList()
        },
        searchReset() {
            this.searchList = {}
            this.getList()
        },
        handleAvatarSuccess() {},
        //上传图片方法
        handleRemove2(file, fileList) {
            console.log(this.formData.photo)
            this.formData.photo.map((item, index) => {
                if (file.response != undefined) {
                    if (item == file.response.content) {
                        this.formData.photo.splice(index, 1)
                    }
                } else {
                    if (item == file.url) {
                        this.formData.photo.splice(index, 1)
                    }
                }
            })
            console.log(this.formData.photo)
        },
        addFunc() {
            this.formData.photo = []
            this.addsend = true
            this.readonly = false
            this.editsend = false
            this.auditsend = false
            console.log(this.addsend)
            this.dialogFormVisible = true
        },
        clearForm() {
            this.dialogFormVisible = false
            this.formData = {}
            this.checkList = []
            this.fileListimg = []
        },
        handlePictureCardPreview2(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible1 = true
        },
        imgok: function (data, data1, data2) {
            if (data.code == 200) {
                if (!this.formData.photo) {
                    this.formData.photo = []
                }
                this.formData.photo.push(data.content)
            }
        },
    },
}
</script>

<style lang="less" scoped>
.main {
    width: 100%;
    height: 100%;
    position: relative;
}
.primarybutton {
    margin: 30px 0;
    text-align: center;
}

/deep/.tabBtn {
    font-size: 18px;
}
.form_input {
    width: 500px;
}
.el-form-item {
    margin-top: 20px;
}
.footer {
    text-align: center;
    margin-left: -140px;
}
</style> 
